import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import GeneralTextBox from './textbox_general';

function PhoneTextBox({ label, id, name, value, onChange, placeholder, required }) {
  const [formattedValue, setFormattedValue] = useState(value);

  useEffect(() => {
    setFormattedValue(formatPhoneNumber(value));
  }, [value]);

  function handleInputChange(e) {
    const formattedInput = formatPhoneNumber(e.target.value);
    if (formattedInput !== formattedValue) {
      setFormattedValue(formattedInput);
      const newEvent = {
        ...e,
        target: {
          ...e.target,
          value: formattedInput,
          name: e.target.name
        },
        persist: () => { }
      };
      onChange(newEvent);
    }
  }

  function formatPhoneNumber(value) {
    const digitsOnly = value.replace(/[^\d]/g, ''); // Strip non-digits
    if (digitsOnly.startsWith('1')) {
      return '+' + digitsOnly;
    } else if (digitsOnly.length <= 10) {
      return '+1' + digitsOnly;
    } else {
      return '+' + digitsOnly;
    }
  }


  return (
    <GeneralTextBox
      label={label}
      id={id}
      name={name}
      type="tel"
      value={formattedValue}
      onChange={handleInputChange}
      placeholder={placeholder}
      required={required}
    />
  );
}

PhoneTextBox.propTypes = {
  label: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
  required: PropTypes.bool
};

PhoneTextBox.defaultProps = {
  placeholder: 'Enter phone number',
  required: false
};

export default PhoneTextBox;
